import React, { FunctionComponent } from "react";
import { useAppSelector } from "../../core/redux/hooks";
import "./Zoom.css";

type Props = {
    tooltipClass: string;
};

const AgentStatusInfoTooltip = ({ tooltipClass }: Props) => {

    let authState = useAppSelector((state) => state.auth);
    const [agentStatusInfo, setAgentStatusInfo] = React.useState<any>({
        online: [],
        busy: [],
        away: []
    });

    React.useEffect(() => {
        let agentStatusInfo: any = {
            online: [],
            busy: [],
            away: []
        }
        authState.allAgentStatusDetails.forEach(agent => {
            // const { status, tenantID, userID, username, email } = agent;
            if (agent?.status === 'online') {
                agentStatusInfo.online.push(agent);
            } else if (agent?.status === 'busy') {
                agentStatusInfo.busy.push(agent);
            } else if (agent?.status === 'away') {
                agentStatusInfo.away.push(agent);
            }
        });
        setAgentStatusInfo({ ...agentStatusInfo });
    }, [authState.allAgentStatusDetails]);

    const capitalizeFirstLetter = (string: string) => {
        try {
            return string[0]?.toUpperCase() + string?.slice(1);
        } catch (error) {
            console.log(error, 'error while capitalizing first letter');
        }
    }

    const calculateTimeInfo = React.useCallback((brbTimestamp: any, brbTimeout: any) => {
        try {
            if (brbTimestamp && brbTimeout) {
                const awaySetTime = new Date(parseInt(brbTimestamp)).toLocaleTimeString([], {
                    hour: "2-digit",
                    minute: "2-digit",
                });
                const awayDuration = brbTimeout / 60;
                const currentTime = Date.now() / 1000;
                const timePassed = currentTime - brbTimestamp / 1000;
                const timeLeft = Math.max(0, awayDuration - timePassed / 60).toFixed(0);

                return { awaySetTime, awayDuration, timeLeft };
            }
        } catch (error) {
            console.log("Error in calculateTimeInfo", error);
        }
    }, []);

    return (
        <>
            <div className={tooltipClass}>


                <table className="table table-bordered" >
                    <thead className="text-center">
                        <tr>
                            <th style={{ width: "30%" }}><span className={" tooltip-online pl-3"}></span> Online ({agentStatusInfo?.online?.length ? agentStatusInfo.online.length : "0"})</th>
                            <th style={{ width: "30%" }}><span className={"col-1 tooltip-busy"}></span> <span className="pl-2">Busy</span> ({agentStatusInfo?.busy?.length ? agentStatusInfo.busy.length : "0"})</th>
                            <th style={{ width: "40%" }}><span className={"col-1 tooltip-away"}></span> <span className="pl-2">Away</span> ({agentStatusInfo?.away?.length ? agentStatusInfo.away.length : "0"})</th>
                        </tr>
                    </thead>
                    <tbody style={{ fontSize: '14px' }}>
                        <tr>
                            {/* Online Agents */}
                            <td className="text-center">
                                {agentStatusInfo?.online?.length > 0 ? (
                                    agentStatusInfo.online.map((agent: any, index: any) => (
                                        <div key={index} className="rows-bordered">
                                            {capitalizeFirstLetter(agent.username)}
                                        </div>
                                    ))
                                ) : (
                                    <div>-</div>
                                )}
                            </td>

                            {/* Busy Agents */}
                            <td className="text-center">
                                {agentStatusInfo?.busy?.length > 0 ? (
                                    agentStatusInfo.busy.map((agent: any, index: any) => (
                                        <div key={index} className="rows-bordered">
                                            {capitalizeFirstLetter(agent.username)}
                                        </div>
                                    ))
                                ) : (
                                    <div>-</div>
                                )}
                            </td>

                            {/* Away Agents */}
                            <td className="text-center">
                                {agentStatusInfo?.away?.length > 0 ? (
                                    agentStatusInfo.away.map((agent: any, index: any) => {
                                        const { awaySetTime, awayDuration, timeLeft }: any = calculateTimeInfo(
                                            agent.brbTimestamp,
                                            agent.brbTimeout
                                        );

                                        return (
                                            <div key={index} className="rows-bordered">
                                                {capitalizeFirstLetter(agent.username)}
                                                <br />
                                                Set at <span className="text-primary">{awaySetTime}</span> for <span className="text-primary">{awayDuration} mins</span>
                                                <br />
                                                <span className="text-primary">{timeLeft} mins</span> left
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div>-</div>
                                )}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div >
        </>

    )
}

export default AgentStatusInfoTooltip;